import React from "react";
import Button from "@insightfulscience/atomic-react/Button";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Block from "@insightfulscience/atomic-react/Block";
import { initialState, validateForm } from "./form";
import { forgotPasswordFormAction } from "./action";

function ForgotPasswordForm() {
	const [t] = useLocale("forgot-password-form");
	const [action, { error, reset, isLoading }] = useFormAction(forgotPasswordFormAction);

	return (
		<>
			{isLoading && <Spinner />}
			<SmartForm textRender={t} {...{ initialState, validateForm, action }} onTouched={reset}>
				<SmartForm.Field
					label="EMAIL"
					name="email"
					type="email"
					disabled={isLoading}
					error={error}
					fieldClassName="mb-8"
					required
					data-qa-selector="forgot-password-email-input"
				/>

				<Row>
					<Col spacing={{ mt: 4, mb: 2 }}>
						<Block sx={{ textAlign: "center" }}>
							<Button
								type="submit"
								disabled={isLoading}
								data-qa-selector="forgot-password-submit-button"
							>
								{t("SUBMIT")}
							</Button>
						</Block>
					</Col>
				</Row>
			</SmartForm>
		</>
	);
}
export default ForgotPasswordForm;
